export default __webpack_public_path__ + "static/media/Strangler's Belt of the Hidden Tomb.ed1ac048.jpg";